import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useRoom } from "../context/RoomContext";
import { useAuth } from "../context/AuthContext";
import "./salle.css";
import ChatRoom from "../components/ChatRoom";
import { meetingsAPI, roomsAPI, fichiersAPI, recordingsAPI } from "../services/api";


import { Search, UserRound, File, Calendar, Edit, Trash2, SendHorizontal, X, UserMinus } from 'lucide-react';

const Salle = () => {
  const navigate = useNavigate();
   const { user } = useAuth();
   const { room, isRecording, recordingStartTime } = useRoom();
   const [searchTerm, setSearchTerm] = useState("");
   const [activeTab, setActiveTab] = useState("reunions");
   const [chatOpen, setChatOpen] = useState(false);
   const [showInviteModal, setShowInviteModal] = useState(false);
   const [inviteeEmail, setInviteeEmail] = useState("");
   const [inviteError, setInviteError] = useState("");
   const [inviteLoading, setInviteLoading] = useState(false);
   const [selectedMeeting, setSelectedMeeting] = useState(null);
   const [showCreateRoom, setShowCreateRoom] = useState(false);
   const [roomName, setRoomName] = useState("");
   const [roomDescription, setRoomDescription] = useState("");
   const [roomStatus, setRoomStatus] = useState("active");
   const [roomCreatedAt, setRoomCreatedAt] = useState(new Date().toISOString().slice(0, 16));
const [createError, setCreateError] = useState("");
   const [createLoading, setCreateLoading] = useState(false);
   const [autoRecording, setAutoRecording] = useState(false);
   const [chatEnabled, setChatEnabled] = useState(true);
   const [screenShareMode, setScreenShareMode] = useState("all");
   const [meetings, setMeetings] = useState([]);
   const [meetingsLoading, setMeetingsLoading] = useState(true);
   const [ownedMeetings, setOwnedMeetings] = useState([]);
   const [roomsLoading, setRoomsLoading] = useState(true);
   const [selectedRoomId, setSelectedRoomId] = useState("");
   const [participants, setParticipants] = useState([]);
   const [participantsLoading, setParticipantsLoading] = useState(false);
   const [files, setFiles] = useState([]);
   const [filesLoading, setFilesLoading] = useState(false);
   const [roomRecordings, setRoomRecordings] = useState([]);
   const [recordingsLoading, setRecordingsLoading] = useState(false);
   const [selectedRecording, setSelectedRecording] = useState(null);
   const [recordingActionLoading, setRecordingActionLoading] = useState(false);
   const [showEditRoom, setShowEditRoom] = useState(false);
   const [editRoomName, setEditRoomName] = useState("");
   const [editRoomDescription, setEditRoomDescription] = useState("");
   const [editRoomStatus, setEditRoomStatus] = useState("active");
   const [editError, setEditError] = useState("");
   const [editLoading, setEditLoading] = useState(false);
   const [deleteLoading, setDeleteLoading] = useState(false);
   const [removeLoading, setRemoveLoading] = useState(false);
   const [removeError, setRemoveError] = useState("");
   const [settingsLoading, setSettingsLoading] = useState(false);
   const [settingsError, setSettingsError] = useState("");

const loadOwnedMeetings = useCallback(async () => {
    try {
      if (!user?.id) return;
      setRoomsLoading(true);
      const response = await meetingsAPI.getAllOwned(user.id);
      if (response.success) {
        setOwnedMeetings(response.data || []);
      }
    } catch (err) {
      console.error("Erreur chargement salles créées:", err);
    } finally {
      setRoomsLoading(false);
    }
  }, [user?.id, setRoomsLoading, setOwnedMeetings]);

  const loadMeetings = useCallback(async () => {
    try {
      if (!user?.id) return;
      setMeetingsLoading(true);
      const response = await meetingsAPI.getUserMeetings(user.id);
      console.log('[loadMeetings] response.data:', response.data);
      if (response.success) {
        setMeetings(response.data || []);
      }
    } catch (err) {
      console.error("Erreur chargement réunions:", err);
    } finally {
      setMeetingsLoading(false);
    }
  }, [user?.id, setMeetingsLoading, setMeetings]);

  // Ajouter des participants: récupère id_meeting INT
  const loadParticipants = useCallback(async (meetingId) => {
    console.log('[loadParticipants] appelé avec meetingId =', meetingId, 'type:', typeof meetingId);
    try {
      setParticipantsLoading(true);
      const response = await roomsAPI.getParticipants(meetingId);
      console.log('[loadParticipants] response:', response);
      if (response.success) {
        setParticipants(response.data || []);
      } else {
        setParticipants([]);
      }
    } catch (err) {
      console.error("Erreur chargement participants:", err);
      setParticipants([]);
    } finally {
      setParticipantsLoading(false);
    }
  }, []); // roomsAPI is an imported module, not a reactive dependency

  useEffect(() => {
     loadMeetings();
     loadOwnedMeetings();
   }, [user?.id, loadMeetings, loadOwnedMeetings]);

   // Charger les participants quand une salle est sélectionnée (par id INT)
   useEffect(() => {
     console.log('[useEffect selectedMeeting]', selectedMeeting);
     if (selectedMeeting?.id) {
       console.log('[useEffect] chargement participants pour id =', selectedMeeting.id);
       loadParticipants(selectedMeeting.id);
     } else {
       console.warn('[useEffect] selectedMeeting sans id valide:', selectedMeeting);
       setParticipants([]);
     }
   }, [selectedMeeting, loadParticipants]);

   // ── FETCH FICHIERS ───────────────────────────────────────────────────────
useEffect(() => {
      const fetchFiles = async () => {
        if (!selectedMeeting?.id) {
          setFiles([]);
          return;
        }
        setFilesLoading(true);
        try {
          const response = await fichiersAPI.getByMeeting(selectedMeeting.id);
          if (response.success) {
            setFiles((response.data || []).map(f => ({
              ...f,
              senderFullName: f.senderFullName
                || [f.senderPrenom, f.senderName]
                    .filter(Boolean)
                    .join(' ')
                    .trim()
                || 'Utilisateur',
            })));
          }
        } catch (err) {
          console.error('Erreur chargement fichiers:', err.message);
        } finally {
          setFilesLoading(false);
        }
      };
      fetchFiles();
    }, [selectedMeeting]);

    const loadRoomRecordings = useCallback(async () => {
      if (!selectedMeeting?.id) {
        setRoomRecordings([]);
        return;
      }
      setRecordingsLoading(true);
      try {
        const response = await recordingsAPI.getMeetingRecordings(selectedMeeting.id);
        if (response.success) {
          setRoomRecordings(response.data || []);
        } else {
          setRoomRecordings([]);
        }
      } catch (err) {
        console.error('Erreur chargement enregistrements:', err.message);
        setRoomRecordings([]);
      } finally {
        setRecordingsLoading(false);
      }
    }, [selectedMeeting?.id]);

    useEffect(() => {
      loadRoomRecordings();
    }, [loadRoomRecordings]);

    useEffect(() => {
      if (selectedMeeting) {
        setAutoRecording(!!(selectedMeeting.auto_recording ?? false));
        setChatEnabled(!!(selectedMeeting.chat_enabled ?? true));
        setScreenShareMode(selectedMeeting.screen_share_mode || "all");
      }
    }, [selectedMeeting]);



  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab !== "discussion") {
      setChatOpen(false);
    }
  };

  const handleInviteSubmit = async (e) => {
    e.preventDefault();
    try {
      setInviteLoading(true);
      setInviteError("");

      // Vérifier qu'une salle est sélectionnée
      console.log('[handleInviteSubmit] selectedRoomId =', selectedRoomId, 'type:', typeof selectedRoomId);
      if (!selectedRoomId) {
        setInviteError("Veuillez sélectionner une salle avant d'ajouter un membre.");
        return;
      }

      // Appel API pour vérifier l'utilisateur et l'ajouter à la salle
      const response = await roomsAPI.addParticipant(selectedRoomId, inviteeEmail.trim(), 'member');

      if (response.success) {
        setInviteeEmail("");
        setShowInviteModal(false);
        alert("Invitation envoyée avec succès à " + inviteeEmail);
        // Recharger les salles et les participants pour que tous voient le nouveau membre
        loadMeetings();
        loadOwnedMeetings();
        if (selectedMeeting) {
          const currentRoomId = selectedMeeting.id_meeting || selectedMeeting.id;
          loadParticipants(currentRoomId);
        }
      } else {
        setInviteError(response.error || "Erreur lors de l'envoi de l'invitation");
      }
    } catch (err) {
      setInviteError(err.message || "Erreur lors de l'envoi de l'invitation");
    } finally {
      setInviteLoading(false);
    }
  };

  const handleCloseInviteModal = () => {
    setShowInviteModal(false);
    setInviteeEmail("");
    setInviteError("");
  };

  const handleCreateRoom = async (e) => {
    e.preventDefault();
    if (!roomName.trim()) {
      setCreateError("Le nom de la salle est requis");
      return;
    }
    setCreateLoading(true);
    setCreateError("");

     try {
       const response = await meetingsAPI.createRoom({
         nom_salle: roomName,
         description: roomDescription,
         statuts: roomStatus
       });

if (response.success) {
           const { data } = response;
           let userObj = null;
           try {
             const userName = sessionStorage.getItem('user');
             userObj = userName ? JSON.parse(userName) : null;
           } catch {
             userObj = null;
           }
           const userNameLabel = userObj?.name || userObj?.email || 'Utilisateur';
           const userId = userObj?.id;
           const userEmail = userObj?.email;
           
           // Store host status for the new room
           sessionStorage.setItem('isHost', 'true');
           sessionStorage.setItem('hostName', userNameLabel);
           
           // Ajouter l'utilisateur qui crée la salle comme participant
           if (userEmail) {
             await roomsAPI.addParticipant(data.id_meeting, userEmail, 'host');
           }
   
           setShowCreateRoom(false);
           setRoomName("");
           setRoomDescription("");
           alert(`Salle créée avec succès !\nCode de la réunion: ${data.meeting_code}\nLien: ${data.meeting_link}`);
           loadMeetings();
           // Navigate to the room - the call will be started via startRoomCall in Room.js
           navigate(`/room/${data.meeting_code}`, { 
             state: { 
               userId: userId,
               userName: userNameLabel,
               isHost: true,
               fromSalle: true
             } 
           });
         } else {
         setCreateError(response.error || "Erreur lors de la création de la salle");
       }
     } catch (err) {
       setCreateError(err.message || "Erreur lors de la création de la salle");
     } finally {
       setCreateLoading(false);
     }
  };

// RoomId utilisé pour la navigation vers Room.js — meeting_code (string UUID)
   const activeRoomId = selectedMeeting?.meeting_code || selectedMeeting?.id_meeting || selectedMeeting?.id || "";

const handleStartMeeting = () => {
      if (!selectedMeeting?.meeting_code) {
        alert('Veuillez sélectionner une salle valide avant de démarrer la réunion.');
        return;
      }
      const userName = user?.name || user?.email || 'Hôte';
      sessionStorage.setItem('isHost', 'true');
      sessionStorage.setItem('hostName', userName);
      navigate(`/room/${selectedMeeting.meeting_code}`, { 
        state: { 
          userId: user?.id,
          userName: userName,
          isHost: true,
          fromSalle: true
        } 
      });
    };

  const hasRoomAccess = room || (meetings && meetings.length > 0);

  const handleCloseCreateRoom = () => {
    setShowCreateRoom(false);
    setRoomName("");
    setRoomDescription("");
    setCreateError("");
  };

  const handleEditRoom = async (e) => {
    e.preventDefault();
    if (!selectedMeeting?.id) return;
    setEditLoading(true);
    setEditError("");
    try {
      const roomId = selectedMeeting.id_meeting || selectedMeeting.id;
      const response = await meetingsAPI.updateRoom(roomId, {
        nom_salle: editRoomName,
        description: editRoomDescription,
        statuts: editRoomStatus,
      });
      if (response.success) {
        setShowEditRoom(false);
        loadMeetings();
        loadOwnedMeetings();
        const updatedMeeting = response.data;
        setSelectedMeeting(updatedMeeting);
      } else {
        setEditError(response.error || "Erreur lors de la modification");
      }
    } catch (err) {
      setEditError(err.message || "Erreur lors de la modification");
    } finally {
      setEditLoading(false);
    }
  };

  const handleDeleteRoom = async () => {
    if (!selectedMeeting?.id) return;
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette salle ?")) return;
    setDeleteLoading(true);
    try {
      const roomId = selectedMeeting.id_meeting || selectedMeeting.id;
      const response = await meetingsAPI.deleteRoom(roomId);
      if (response.success) {
        setSelectedMeeting(null);
        loadMeetings();
        loadOwnedMeetings();
      } else {
        alert(response.error || "Erreur lors de la suppression");
      }
    } catch (err) {
      alert(err.message || "Erreur lors de la suppression");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleOpenEditRoom = () => {
    if (selectedMeeting) {
      setEditRoomName(selectedMeeting.nom_salle || selectedMeeting.name || "");
      setEditRoomDescription(selectedMeeting.description || selectedMeeting.description_salle || "");
      setEditRoomStatus(selectedMeeting.statuts || selectedMeeting.status || "active");
      setEditError("");
      setShowEditRoom(true);
    }
  };

  const handleCloseEditRoom = () => {
    setShowEditRoom(false);
    setEditRoomName("");
    setEditRoomDescription("");
    setEditError("");
  };

  const handleRemoveParticipant = async (participantId, participantName) => {
    if (!selectedMeeting?.id) return;
    if (!window.confirm(`Êtes-vous sûr de vouloir supprimer ${participantName || 'ce participant'} de la salle ?`)) return;
    setRemoveLoading(true);
    setRemoveError("");
    try {
      const roomId = selectedMeeting.id_meeting || selectedMeeting.id;
      const response = await roomsAPI.removeParticipant(roomId, participantId);
      if (response.success) {
        setParticipants(prev => prev.filter(p => String(p.iduser) !== String(participantId)));
      } else {
        setRemoveError(response.error || "Erreur lors de la suppression du participant");
      }
    } catch (err) {
      setRemoveError(err.message || "Erreur lors de la suppression");
    } finally {
      setRemoveLoading(false);
    }
  };

  const handleSaveSettings = async () => {
    if (!selectedMeeting?.id) return;
    setSettingsLoading(true);
    setSettingsError("");
    try {
      const roomId = selectedMeeting.id_meeting || selectedMeeting.id;
      const response = await meetingsAPI.updateRoomSettings(roomId, {
        auto_recording: autoRecording,
        chat_enabled: chatEnabled,
        screen_share_mode: screenShareMode
      });
      if (response.success) {
        alert("Paramètres enregistrés avec succès");
      } else {
        setSettingsError(response.error || "Erreur lors de l'enregistrement des paramètres");
      }
    } catch (err) {
      setSettingsError(err.message || "Erreur lors de l'enregistrement des paramètres");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleCancelSettings = () => {
    if (selectedMeeting) {
      setAutoRecording(!!(selectedMeeting.auto_recording ?? false));
      setChatEnabled(!!(selectedMeeting.chat_enabled ?? true));
      setScreenShareMode(selectedMeeting.screen_share_mode || "all");
    }
    setSettingsError("");
  };

  const handleDeleteRecording = async (recordingId) => {
    if (!recordingId || !window.confirm("Êtes-vous sûr de vouloir supprimer cet enregistrement ?")) return;
    setRecordingActionLoading(true);
    try {
      const response = await recordingsAPI.deleteRecording(recordingId);
      if (response.success) {
        setRoomRecordings(prev => prev.filter(r => r.id !== recordingId));
        setSelectedRecording(null);
      } else {
        alert(response.error || "Erreur lors de la suppression");
      }
    } catch (err) {
      alert(err.message || "Erreur lors de la suppression");
    } finally {
      setRecordingActionLoading(false);
    }
  };

  return (
    <div className="modern-app">
      <div className="main-content">
        <header className="app-header">
          <div className="header-top">
            <div className="header-left">
             {/* <p className="room-description">Salle !</p>*/}
            </div>
            <div className="header-right">
              {/*
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button className="search-btn"><Search /></button>
              </div>
              */}
              <div className="user-profile">
                <span>{user?.name || user?.email || 'Utilisateur'}</span>
                {/*<div className="avatar-fallback" alt="User"></div>*/}
              </div>
            </div>
          </div>
          <div className="meetings-header">
            {meetingsLoading ? (
              <span className="meeting-name-tag">Chargement...</span>
            ) : meetings.length === 0 ? (
              <span className="meeting-name-tag">Aucune salle</span>
            ) : (
              meetings.map((meeting) => (
                <span
                  key={meeting.id}
                  className={`meeting-name-tag ${selectedMeeting && selectedMeeting.id === meeting.id ? 'active' : ''}`}
                  onClick={() => {
                    console.log('[click] meeting =', meeting);
                    setSelectedMeeting(meeting);
                  }}
                >
                  {meeting.nom_salle || meeting.name}
                </span>
              ))
            )}
          </div>
        </header>

        <div className="create-room-section">
          <button className="btn-create-room" onClick={() => setShowCreateRoom(true)}>
            + Créer une salle
          </button>
        </div>

        {hasRoomAccess && (
          <>
            <nav className="tabs">
              <button
                className={`tab-item ${activeTab === "discussion" ? "active-tab" : ""}`}
                onClick={() => handleTabClick("discussion")}
              >
                Discussion
              </button>
              <button
                className={`tab-item ${activeTab === "enregistrements" ? "active-tab" : ""}`}
                onClick={() => handleTabClick("enregistrements")}
              >
                Enregistrement
              </button>
              <button
                className={`tab-item ${activeTab === "fichiers" ? "active-tab" : ""}`}
                onClick={() => handleTabClick("fichiers")}
              >
                Fichiers
              </button>
              <button
                className={`tab-item ${activeTab === "reunions" ? "active-tab" : ""}`}
                onClick={() => handleTabClick("reunions")}
              >
                Réunions
              </button>
              <button
                className={`tab-item ${activeTab === "parametres" ? "active-tab" : ""}`}
                onClick={() => handleTabClick("parametres")}
              >
                Paramètres
              </button>
            </nav>

            <div className="content">
               <section className="left-panel">
                  {activeTab === "discussion" ? (
                    <ChatRoom
                      roomId={selectedMeeting?.meeting_code || selectedMeeting?.id_meeting || selectedMeeting?.id || ""}
                      isOpen={true}
                      mode="page"
                      variant="room"
                    />
) : activeTab === "enregistrements" ? (
                    <div className="card">
                      <h2>Vidéos enregistrées</h2>
                      {recordingsLoading ? (
                        <p className="participants-loading">Chargement des enregistrements...</p>
                      ) : roomRecordings.length === 0 ? (
                        <p className="participants-empty">Aucun enregistrement dans cette salle.</p>
                      ) : (
selectedRecording ? (
                           <div className="video-player-container">
                             <div className="video-player-header">
                               <h3>{selectedRecording.fileName || 'Enregistrement'}</h3>
                               <button className="btn-outline" onClick={() => setSelectedRecording(null)}>Retour</button>
                             </div>
                             <video 
                               className="recording-video-player"
                               controls 
                               autoPlay
                               src={selectedRecording.playUrl}
                             />
                             <div className="recording-info-full">
                               <p><span>📅</span> {selectedRecording.dateEnregist ? new Date(selectedRecording.dateEnregist).toLocaleString('fr-FR') : ''}</p>
                               <p><span>⏱️</span> {selectedRecording.duree || '—'}</p>
                               <div className="button-group">
                                 <a href={selectedRecording.playUrl} download className="btn-primary">Télécharger</a>
                               </div>
                             </div>
                           </div>
                         ) : (
<div className="recordings-list">
                             {roomRecordings.map((recording) => {
                               const getBaseUrl = () => {
                                 const envUrl = process.env.REACT_APP_API_URL;
                                 if (envUrl) return envUrl.replace(/\/api\/?$/, '');
                                 const hostname = window.location.hostname;
                                 const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
                                 return `${protocol}//${hostname}:3001`;
                               };
                               const playUrl = recording.filePath?.startsWith('http')
                                 ? recording.filePath
                                 : `${getBaseUrl()}${recording.filePath}`;
                               return (
                                 <div className="recording-item" key={recording.id}>
                                   <div className="recording-thumbnail">
                                     <div className="video-placeholder"><SendHorizontal /></div>
                                     <span className="duration">{recording.duree || '—'}</span>
                                   </div>
                                   <div className="recording-info">
                                     <h3>{selectedMeeting?.nom_salle || selectedMeeting?.name || 'Réunion'}</h3>
                                     <p><span>📅</span> {recording.dateEnregist ? new Date(recording.dateEnregist).toLocaleDateString('fr-FR') : ''} • 1080p HD</p>
                                     <div className="button-group">
                                       <button className="btn-outline" onClick={() => setSelectedRecording({ ...recording, playUrl })}>Regarder</button>
                                       <a href={playUrl} download className="btn-primary">Télécharger</a>
                                       <button 
                                         className="btn-secondary btn-delete-recording" 
                                         onClick={() => handleDeleteRecording(recording.id)}
                                         disabled={recordingActionLoading}
                                       >
                                         Supprimer
                                       </button>
                                     </div>
                                   </div>
                                 </div>
                               );
                             })}
                           </div>
                        )
                      )}
                    </div>
                  ) : activeTab === "fichiers" ? (
                  <div className="card">
                    <h2>Fichiers partagés</h2>
                    {filesLoading ? (
                      <p className="participants-loading">Chargement des fichiers...</p>
                    ) : files.length === 0 ? (
                      <p className="participants-empty">Aucun fichier partagé dans cette salle.</p>
                    ) : (
                      <div className="files-list">
                        {files.map((file) => {
                          const getBaseUrl = () => {
                            const envUrl = process.env.REACT_APP_API_URL;
                            if (envUrl) return envUrl.replace(/\/api\/?$/, '');
                            const hostname = window.location.hostname;
                            const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
                            return `${protocol}//${hostname}:3001`;
                          };
                          const openUrl = file.url.startsWith('http')
                            ? file.url
                            : `${getBaseUrl()}${file.url}`;
                          return (
                            <div className="file-item" key={file.idfichier}>
                              <div className="file-icon"><span><File /></span></div>
                              <div className="file-info">
                                <h3>{file.nomfichier}</h3>
                                <p><span><Calendar /></span> {file.date_envoi ? new Date(file.date_envoi).toLocaleDateString('fr-FR') : ''} • {(file.taille / 1024).toFixed(1)} KB • {file.typefichier?.toUpperCase() || 'FILE'}</p>
                                <p><span><UserRound /></span> Partagé par: {file.senderFullName || 'Utilisateur'}</p>
                              </div>
                              <div className="file-actions">
                                <a href={openUrl} target="_blank" rel="noopener noreferrer" className="btn-outline">Ouvrir</a>
                                <a href={openUrl} download className="btn-outline">Télécharger</a>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
</div>
                        ) : activeTab === "parametres" ? (
                    <div className="card">
                      <h2>Paramètres de la salle</h2>
                      {settingsError && <div className="error-message" style={{marginBottom: '16px'}}>{settingsError}</div>}
                      <div className="settings-list">
                        <div className="setting-item">
                          <div className="setting-info">
                            <h3>Nom de la salle</h3>
                            <p>{selectedMeeting?.nom_salle || selectedMeeting?.name || "—"}</p>
                          </div>
                          <button className="btn-outline" onClick={handleOpenEditRoom}>Modifier</button>
                        </div>
                        <div className="setting-item">
                          <div className="setting-info">
                            <h3>Visibilité</h3>
                            <p>Privée - Les membres doivent être invités</p>
                          </div>
                          <button className="btn-outline">Modifier</button>
                        </div>
                        <div className="setting-item">
                          <div className="setting-info">
                            <h3>Enregistrement automatique</h3>
                            <p>{autoRecording ? "Activé" : "Désactivé"}</p>
                          </div>
                          <label className="toggle-switch">
                            <input 
                              type="checkbox" 
                              checked={autoRecording}
                              onChange={(e) => setAutoRecording(e.target.checked)}
                            />
                            <span className="toggle-slider"></span>
                          </label>
                        </div>
                        <div className="setting-item">
                          <div className="setting-info">
                            <h3>Chat actif</h3>
                            <p>Les participants peuvent discuter</p>
                          </div>
                          <label className="toggle-switch">
                            <input 
                              type="checkbox" 
                              checked={chatEnabled}
                              onChange={(e) => setChatEnabled(e.target.checked)}
                            />
                            <span className="toggle-slider"></span>
                          </label>
                        </div>
                        <div className="setting-item">
                          <div className="setting-info">
                            <h3>Partage d'écran</h3>
                            <p>{screenShareMode === "all" ? "Tous les participants" : "Hôte uniquement"}</p>
                          </div>
                          <select 
                            value={screenShareMode}
                            onChange={(e) => setScreenShareMode(e.target.value)}
                            className="btn-outline"
                            style={{appearance: 'none', padding: '8px 16px', fontSize: '14px'}}
                          >
                            <option value="all">Tous les participants</option>
                            <option value="host_only">Hôte uniquement</option>
                          </select>
                        </div>
                      </div>
                      <div className="button-group">
                        <button className="btn-primary" onClick={handleSaveSettings} disabled={settingsLoading}>
                          {settingsLoading ? "Enregistrement..." : "Enregistrer les modifications"}
                        </button>
                        <button className="btn-secondary" onClick={handleCancelSettings}>Annuler</button>
                      </div>
                    </div>
                  ) : (
                  <>
                    <div className="card">
                      <h2>Aucune réunion en cours</h2>
                      <p>Démarrez une réunion pour commencer à collaborer</p>
                      <div className="button-group">
                        <button className="btn-primary" onClick={handleStartMeeting}>Démarrer une réunion</button>
                        {/*
                        <button className="btn-secondary">Planifier</button>
                        */ }
                      </div>
                    </div>
                    {/*
                    <div className="card">
                      <h2>Réunions récentes</h2>
                      <div className="meeting-list">
                        <div className="meeting-item">
                          <div className="meeting-info">
                            <h3>Réunion projet</h3>
                            <p><span>📅</span> 10 mai 2024 • 14:30</p>
                          </div>
                        </div>
                        <div className="meeting-item">
                          <div className="meeting-info">
                            <h3>Point équipe</h3>
                            <p><span>📅</span> 3 mai 2024 • 09:15</p>
                          </div>
                        </div>
                        <div className="meeting-item">
                          <div className="meeting-info">
                            <h3>Review design</h3>
                            <p><span>📅</span> 28 avril 2024 • 16:00</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    */}
                  </>
                )}
              </section>

              <section className="right-panel">
{selectedMeeting && (
                <div className="card">
                  <div className="card-header-with-actions">
                    <h2>À propos de cette salle</h2>
                    {user?.id && selectedMeeting.iduser && String(user.id) === String(selectedMeeting.iduser) && (
                      <div className="room-actions">
                        <button className="btn-icon btn-edit" onClick={handleOpenEditRoom} title="Modifier la salle">
                          <Edit size={18} />
                        </button>
                        <button className="btn-icon btn-delete" onClick={handleDeleteRoom} disabled={deleteLoading} title="Supprimer la salle">
                          <Trash2 size={18} />
                        </button>
                      </div>
                    )}
                  </div>
                  <p><strong>Nom :</strong> {selectedMeeting.nom_salle || selectedMeeting.name}</p>
                  <p><strong>Créé par :</strong> {selectedMeeting.created_by || user?.name || user?.email || 'Utilisateur'}</p>
                  <p><strong>Créé le :</strong> {selectedMeeting.created_at ? new Date(selectedMeeting.created_at).toLocaleDateString('fr-FR') : '—'}</p>
                  <p><strong>Code :</strong> {selectedMeeting.code_reunion || selectedMeeting.meeting_code || '—'}</p>
                  <p><strong>Statut :</strong> {selectedMeeting.statuts || selectedMeeting.status || 'Active'}</p>
                  <p><strong>Description :</strong> {selectedMeeting.description || selectedMeeting.description_salle || 'Aucune description'}</p>
                </div>
               )}
              <div className="card">
                    <h2>Membres</h2>
                    {participantsLoading ? (
                      <p className="participants-loading">Chargement des participants...</p>
                    ) : removeError ? (
                      <p className="participants-error">{removeError}</p>
                    ) : (
                      <div className="members-list">
                        {/* Afficher tous les participants avec leur rôle - le créateur a le rôle "host" */}
                        {participants.length > 0 ? (
                          participants.map((p, index) => {
                            const isCreator = p.role === 'host' || p.role === 'owner' || p.role === 'admin';
                            const creatorId = selectedMeeting?.iduser;
                            const isRealCreator = creatorId && String(p.iduser) === String(creatorId);
                            const viewerIsCreator = user?.id && selectedMeeting?.iduser && String(user.id) === String(selectedMeeting.iduser);
                            const canRemove = viewerIsCreator && !isRealCreator;
                            
                            return (
                              <div className="member-item" key={p.iduser || p.idparticipant || index}>
                                <div className="member-avatar">
                                  <div className="avatar-fallback" alt={p.nom || p.email}>
                                    {(p.nom || p.email || '?')[0].toUpperCase()}
                                  </div>
                                  {/*
                                  <span className={p.etat_presence === 'present' ? 'online-indicator' : 'offline-indicator'}>
                                    {p.etat_presence === 'present' ? 'En ligne' : 'Hors ligne'}
                                  </span>
                                  */}
                                </div>
                                <div className="member-info">
                                  <h3>{p.nom || p.email}</h3>
                                  <p>
                                    {isRealCreator 
                                      ? 'Créateur (Hôte)' 
                                      : isCreator 
                                        ? 'Administrateur' 
                                        : 'Membre'}
                                  </p>
                                </div>
                                {canRemove && (
                                  <button 
                                    className="btn-remove-member" 
                                    onClick={() => handleRemoveParticipant(p.iduser, p.nom || p.email)} 
                                    title="Supprimer de la salle"
                                    disabled={removeLoading}
                                  >
                                    <UserMinus size={16} />
                                  </button>
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <p className="participants-empty">Aucun participant dans cette salle.</p>
                        )}
                      </div>
                    )}
                    <button className="btn-full-outline" onClick={() => setShowInviteModal(true)}>
                      Ajouter des membres
                    </button>
                  </div>
                  {/*
                 <div className="card" style={{ backgroundColor: '#f8fafc', borderLeft: '4px solid #10b981' }}>
                   <h2>Enregistrement de la salle</h2>
                   {isRecording ? (
                     <>
                       <p><strong>Statut :</strong> <span style={{ color: '#10b981' }}>Enregistrement en cours</span></p>
                       <p><strong>Débuté le :</strong> {recordingStartTime ? new Date(recordingStartTime).toLocaleString('fr-FR') : '—'}</p>
                       <p><strong>Durée :</strong> {recordingStartTime ? (() => {
                         const diff = new Date() - new Date(recordingStartTime);
                         const hours = Math.floor(diff / 3600000);
                         const minutes = Math.floor((diff % 3600000) / 60000);
                         const seconds = Math.floor((diff % 60000) / 1000);
                         return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                       })() : '00:00:00'}</p>
                       <p><strong>Taille du fichier :</strong> En cours...</p>
                       <p><strong>Qualité :</strong> 1080p HD</p>
                     </>
                   ) : (
                     <>
                       <p><strong>Statut :</strong> <span style={{ color: '#6b7280' }}>Enregistrement arrêté</span></p>
                       <p><strong>Débuté le :</strong> — </p>
                       <p><strong>Durée :</strong> 00:00:00</p>
                       <p><strong>Taille du fichier :</strong> — </p>
                       <p><strong>Qualité :</strong> 1080p HD</p>
                     </>
                   )}
                 </div>
                  */}
              </section>
            </div>
          </>
        )}
      </div>

      {chatOpen && (
        <ChatRoom
          roomId={activeRoomId}
          isOpen={chatOpen}
          onClose={() => { setChatOpen(false); setActiveTab("reunions"); }}
          mode="panel"
          variant="room"
        />
      )}

      {showInviteModal && (
        <div className="modal-overlay" onClick={handleCloseInviteModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Ajouter un membre par email</h3>
              <button className="modal-close" onClick={handleCloseInviteModal}>×</button>
            </div>
            <form className="invite-modal-form" onSubmit={handleInviteSubmit}>
              {inviteError && <div className="error-message">{inviteError}</div>}
              <div className="form-group">
                <label htmlFor="roomSelect">Salle</label>
                {roomsLoading ? (
                  <select disabled>
                    <option>Chargement des salles...</option>
                  </select>
                ) : ownedMeetings.length === 0 ? (
                  <p className="no-rooms-message">Aucune salle disponible. Créez d'abord une salle pour pouvoir ajouter des membres.</p>
                ) : (
                  <select
                    id="roomSelect"
                    value={selectedRoomId}
                    onChange={(e) => setSelectedRoomId(e.target.value)}
                  >
                    <option value="">-- Choisir une salle --</option>
                    {ownedMeetings.map((meeting) => (
                    <option key={meeting.id} value={meeting.id}>
                      {meeting.nom_salle}
                    </option>
                    ))}
                  </select>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="inviteeEmail">Email du participant</label>
                <input
                  type="email"
                  id="inviteeEmail"
                  value={inviteeEmail}
                  onChange={(e) => setInviteeEmail(e.target.value)}
                  placeholder="entrez@email.com"
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={inviteLoading}>
                {inviteLoading ? 'Ajout en cours...' : "Ajouter le membre"}
              </button>
            </form>
          </div>
        </div>
      )}

      {showCreateRoom && (
        <div className="modal-overlay" onClick={handleCloseCreateRoom}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Créer une nouvelle salle</h3>
              <button className="modal-close" onClick={handleCloseCreateRoom}>×</button>
            </div>
            <form className="create-room-form" onSubmit={handleCreateRoom}>
              {createError && <div className="error-message">{createError}</div>}
              <div className="form-group">
                <label htmlFor="roomName">Nom de la salle</label>
                <input
                  type="text"
                  id="roomName"
                  value={roomName}
                  onChange={(e) => setRoomName(e.target.value)}
                  placeholder="Entrez le nom de la salle"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="roomDescription">Description</label>
                <textarea
                  id="roomDescription"
                  value={roomDescription}
                  onChange={(e) => setRoomDescription(e.target.value)}
                  placeholder="Entrez une description pour la salle"
                  rows={4}
                />
              </div>
              <div className="form-group">
                <label htmlFor="roomStatus">Status</label>
                <select
                  id="roomStatus"
                  value={roomStatus}
                  onChange={(e) => setRoomStatus(e.target.value)}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="maintenance">Maintenance</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="roomCreatedAt">Date de création</label>
                <input
                  type="datetime-local"
                  id="roomCreatedAt"
                  value={roomCreatedAt}
                  onChange={(e) => setRoomCreatedAt(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={createLoading}>
                {createLoading ? 'Création...' : 'Créer la salle'}
              </button>
            </form>
          </div>
        </div>
      )}

      {showEditRoom && (
        <div className="modal-overlay" onClick={handleCloseEditRoom}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Modifier la salle</h3>
              <button className="modal-close" onClick={handleCloseEditRoom}>×</button>
            </div>
            <form className="create-room-form" onSubmit={handleEditRoom}>
              {editError && <div className="error-message">{editError}</div>}
              <div className="form-group">
                <label htmlFor="editRoomName">Nom de la salle</label>
                <input
                  type="text"
                  id="editRoomName"
                  value={editRoomName}
                  onChange={(e) => setEditRoomName(e.target.value)}
                  placeholder="Entrez le nom de la salle"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="editRoomDescription">Description</label>
                <textarea
                  id="editRoomDescription"
                  value={editRoomDescription}
                  onChange={(e) => setEditRoomDescription(e.target.value)}
                  placeholder="Entrez une description pour la salle"
                  rows={4}
                />
              </div>
              <div className="form-group">
                <label htmlFor="editRoomStatus">Status</label>
                <select
                  id="editRoomStatus"
                  value={editRoomStatus}
                  onChange={(e) => setEditRoomStatus(e.target.value)}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="maintenance">Maintenance</option>
                </select>
              </div>
              <button type="submit" className="btn-primary" disabled={editLoading}>
                {editLoading ? 'Modification...' : 'Enregistrer les modifications'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Salle;
